/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import { toast } from 'react-toastify';
import AppForm from './AppForm';
import { getAllApplication } from '../../../../../../store/reducers/application/applicationAction';
import { editApplication } from '../../../../../../services/application/Application';

const AppEdit = ({ handleClose, selectedApplication }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ detailName, detailValue }, { setSubmitting }) => {
        setSubmitting(true)
        try {
            await editApplication({
                applicationName: selectedApplication.applicationName, applicationID: selectedApplication.applicationID, applicationDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Application was edited successfully');
            handleClose();
            await dispatch(getAllApplication()).unwrap();
            setSubmitting(false)

        } catch (error) {
            setSubmitting(false)

            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Application  Edit</Typography>
            <Formik
                initialValues={{
                    detailName: selectedApplication.applicationDetails[0].detailName,
                    detailValue: selectedApplication.applicationDetails[0].detailValue,

                }}

                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <AppForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default AppEdit;